import { cn } from "@/lib/utils";

/**
 * Official Vest Maskinservice brand assets (vector SVG in /public/brand).
 *
 * variant: "horizontal" | "stacked" | "symbol"
 * onDark:  use the white/orange version for dark surfaces
 *
 * Width is always derived from the asset's real aspect ratio so the mark can
 * never be stretched by a flex/grid parent.
 */
const ASSETS = {
  horizontal: { light: "logo-horizontal.svg", dark: "logo-horizontal-secondary.svg", ratio: 653 / 82.2 },
  stacked: { light: "logo-stacked.svg", dark: "logo-stacked-secondary.svg", ratio: 479 / 213.2 },
  symbol: { light: "symbol.svg", dark: "symbol-secondary.svg", ratio: 446 / 146 },
};

export const Logo = ({ variant = "horizontal", onDark = false, className, height = 32, alt = "Vest Maskinservice", ...rest }) => {
  const asset = ASSETS[variant] || ASSETS.horizontal;
  const width = Math.round(height * asset.ratio);
  return (
    <img
      src={`/brand/${onDark ? asset.dark : asset.light}`}
      alt={alt}
      data-testid="app-logo"
      width={width}
      height={height}
      style={{ width, height }}
      className={cn("block shrink-0 select-none", className)}
      draggable={false}
      decoding="async"
      {...rest}
    />
  );
};

/** Small orange stroke icon (favicon mark) – for decorative use */
export const BrandMark = ({ size = 20, className }) => {
  const w = Math.round(size * (245.8 / 201.8));
  return (
    <img
      src="/brand/icon.svg"
      alt=""
      aria-hidden="true"
      width={w}
      height={size}
      style={{ width: w, height: size }}
      className={cn("block shrink-0 select-none", className)}
      draggable={false}
    />
  );
};
